import { useFetchLoanApplications } from './useFetchLoanApplications';
import { useFetchLoans } from './useFetchLoans';

const useLoansDashboard = () => {
  const { data: applications, ...applicationsRest } = useFetchLoanApplications();

  // TODO: at the moment we're assuming there's only one application per user
  const application = applications?.[0];

  const { data: loans, ...loansRest } = useFetchLoans({
    enabled: application?.status === 'APPROVED',
  });

  return { loans, applications, applicationsRest, loansRest };
};

export { useLoansDashboard };
